import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const row1 = [{
  name: '365id',
  src: 'https://cdn.magicpatterns.com/uploads/rqVWtFRFLKLq3drXrw1jPi/365id_newlogo_2021_payoff.png'
}, {
  name: 'Sense4 Solutions',
  src: 'https://cdn.magicpatterns.com/uploads/goLaDEhDvjT9D9TTh2ER1M/1634310000876.jpg'
}, {
  name: 'Elite Dental Academy',
  src: 'https://cdn.magicpatterns.com/uploads/3q1PXP1ecMWM9crJs7XcTq/elite.png'
}, {
  name: 'Frihet i Rörelse',
  src: 'https://cdn.magicpatterns.com/uploads/a9i9CmazLxndHfV2bQWmf7/Frihet-i-Rorelse_logo-med-text-genomskinlig.png'
}, {
  name: 'HMS',
  src: 'https://cdn.magicpatterns.com/uploads/7dYz99vcPzCiPx3Mj4p2hA/HMS_logo.png'
}, {
  name: 'IHM Business School',
  src: 'https://cdn.magicpatterns.com/uploads/4YVo5PMJsQq25VB39S2zUW/IHM_LOGO_BLACK_MEDIUM.png'
}, {
  name: 'Mytolia',
  src: 'https://cdn.magicpatterns.com/uploads/21DEoEoVSRVjVkpEifewC8/Mytolia-logo2025.webp'
}, {
  name: 'Newton',
  src: 'https://cdn.magicpatterns.com/uploads/g6MNik5LphUyqyD17RWvQZ/newton-logo-orange-platta.png'
}, {
  name: 'Nordway Store',
  src: 'https://cdn.magicpatterns.com/uploads/1eKnyUVcvnTwhJV5BsKMwK/nordway_store.png'
}];
const row2 = [{
  name: 'Pensionsmyndigheten',
  src: 'https://cdn.magicpatterns.com/uploads/dCn91eJUT7hAS4YjMqZ8eG/pension_stor.png'
}, {
  name: 'Region Blekinge',
  src: 'https://cdn.magicpatterns.com/uploads/qsQAEp8ei9WLywNUVVmsrn/Region_Blekinge_logotyp_svart_webb.png'
}, {
  name: 'Rum och Miljö',
  src: 'https://cdn.magicpatterns.com/uploads/tnFVsDdnVvipEmdNxXLQ9R/rumochmiljo-portfolio-logo.png'
}, {
  name: 'Scania',
  src: 'https://cdn.magicpatterns.com/uploads/vcD119PSwNEWVvJJLC2fGh/scania.png'
}, {
  name: 'Skatteverket',
  src: 'https://cdn.magicpatterns.com/uploads/iZfUNiQ5SKi1vvrNX2GNSK/skatteverket.png'
}, {
  name: 'Supertrade',
  src: 'https://cdn.magicpatterns.com/uploads/4t57RU362Nf3ZXLNBhmbVM/Supertrade-logo.png'
}, {
  name: 'Svenska Mässan',
  src: 'https://cdn.magicpatterns.com/uploads/eaDVMKKnAAaqzL1RvPB7DY/svenska_massan.webp'
}, {
  name: 'Tekå Persienner',
  src: 'https://cdn.magicpatterns.com/uploads/gh1HtCpE5u5YpgYr6oXPcG/teka-logga.jpg'
}, {
  name: 'Vattenfall',
  src: 'https://cdn.magicpatterns.com/uploads/w6BUYScBzMbaob27psf5Aq/vattenfall.png'
}];
const testimonials = [{
  quote: 'Peter har med sitt coachande förhållningssätt och nya perspektiv varit ett stort stöd i förändringsarbetet. Genom digitala workshops har han bidragit till ökad digital mognad och bättre samarbete.',
  role: 'Chef projektkontor, större organisation'
}, {
  quote: 'Peter har förmågan att ställa de frågor som ifrågasätter de begränsningar man sätter för sig själv, samtidigt som man får både tänkvärda och praktiska verktyg för att komma fram till helt nya slutsatser.',
  role: 'Entreprenör & mäklare'
}, {
  quote: 'Peter har ett kombinerat lugn och driv som jag aldrig annars sett hos en entreprenör. Han är ett otroligt bra bollplank och en utmärkt coach oavsett vilken fas i livet eller företaget jag befinner mig.',
  role: 'Ägare/VD'
}];
function LogoRow({
  logos,
  direction
}: {
  logos: typeof row1;
  direction: 'left' | 'right';
}) {
  const doubled = [...logos, ...logos];
  return <div className="relative overflow-hidden" data-id="element-194">
      {/* Fade edges */}
      <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none" data-id="element-195" />
      <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none" data-id="element-196" />

      <div className={`flex items-center gap-16 ${direction === 'left' ? 'animate-marquee-left' : 'animate-marquee-right'}`} style={{
      width: 'max-content'
    }} data-id="element-197">
        {doubled.map((logo, i) => <img key={`${logo.name}-${i}`} src={logo.src} alt={logo.name} className="h-10 w-auto object-contain grayscale opacity-50 flex-shrink-0" loading="lazy" data-id="element-198" />)}
      </div>
    </div>;
}
export function SocialProof() {
  return <section className="py-20 md:py-28 px-6 bg-background overflow-hidden" data-id="element-199">
      <style data-id="element-200">{`
        @keyframes marquee-left {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes marquee-right {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
        .animate-marquee-left {
          animation: marquee-left 45s linear infinite;
        }
        .animate-marquee-right {
          animation: marquee-right 50s linear infinite;
        }
      `}</style>

      <div className="max-w-7xl mx-auto" data-id="element-201">
        {/* Logo cloud */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-20" data-id="element-202">
          <p className="text-center text-sage font-medium tracking-widest text-xs uppercase mb-10" data-id="element-203">
            Några av de vi jobbat med
          </p>

          <div className="space-y-8" data-id="element-204">
            <LogoRow logos={row1} direction="left" data-id="element-205" />
            <LogoRow logos={row2} direction="right" data-id="element-206" />
          </div>
        </motion.div>

        {/* Testimonials */}
        <div className="max-w-5xl mx-auto" data-id="element-207">
          <motion.p className="text-center text-terracotta font-medium tracking-widest text-xs uppercase mb-10" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-208">
            Vad andra säger
          </motion.p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-209">
            {testimonials.map((t, i) => <motion.div key={i} className="bg-card rounded-2xl p-8 border border-border/50" initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.12
          }} data-id="element-210">
                {/* Quote mark */}
                <span className="text-terracotta/25 text-5xl font-serif leading-none block mb-4" data-id="element-211">
                  "
                </span>
                <p className="text-muted text-sm leading-relaxed mb-6" data-id="element-212">
                  {t.quote}
                </p>
                <p className="text-xs text-muted/60 font-medium" data-id="element-213">— {t.role}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}